import { ReactComponent as Copy } from 'icons/Copy.svg';
import styled from 'styled-components';
import { Icons } from '@social-solutions/component-library';
import theme from 'theme';

export const SSOCopyIcon = styled(Copy)`
  width: 15px;
  height: 20px;
  padding-left:1px;
  &:hover {
    background-color: ${theme.jaundice};
    outline: none;
  }
`;

export const IconWrapper = styled.div`
  border-radius: 50%;
  width: 18px;
  height: 18px;
  padding: 10px;
  &:hover {
    cursor: pointer;
    background-color: ${theme.jaundice};
    outline: none;
  }
`;

export const EditIcon = styled(Icons.Pencil)`
  font-size: 18px;
  padding-top: 1px;
  &:hover {
    background-color: ${theme.jaundice};
    outline: none;
  }
`;
